import "./index.css";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Navbar from "./components/Navbar";

// Screens
import HomeScreen from "./screens/HomeScreen";
import ProductScreen from "./screens/ProductScreen";
import CartScreen from "./screens/CartScreen";
import OrderScreen from "./screens/OrderScreen";
import RegisterScreen from "./screens/RegisterScreen";
import { useDispatch, useSelector } from "react-redux";
import { getStoreInfo } from "./redux/actions/storeInfo";
import CheckOutSuccess from "./screens/CheckOutSuccess";
import Footer from "./components/Footer";
import Shop from "./screens/Shop";
import Account from "./screens/Account";
import AboutScreen from "./screens/AboutScreen";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import TermAndConditions from "./screens/TermAndConditions";
import ContactScreen from "./screens/ContactScreen";
import useLocalStorage from "use-local-storage";

function App() {
  const dispatch = useDispatch();
  const currentUser = JSON.parse(localStorage.getItem("profile"));
  const cc = useSelector((state) => state.store)?.store?.storeInfo?.currency;
  const storeCurrency = cc ? cc.substring(0, 1) : cc;
  const storeName = useSelector((state) => state.store)?.store?.storeInfo?.name;

  const defaultDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [theme, setTheme] = useLocalStorage(
    "theme",
    defaultDark ? "dark" : "light"
  );

  useEffect(() => {
    dispatch(getStoreInfo());
  }, [dispatch]);

  const switchTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
  };

  return (
    <main className="app relative" data-theme={theme}>
      <button onClick={switchTheme} className="theme">
        {theme === "light" ? (
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-moon-fill"
              viewBox="0 0 16 16"
            >
              <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z" />
            </svg>
          </div>
        ) : (
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-brightness-high-fill"
              viewBox="0 0 16 16"
            >
              <path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z" />
            </svg>
          </div>
        )}
      </button>

      <Router>
        <Navbar currentUser={currentUser} storeName={storeName} theme={theme} />
        <Routes>
          <Route
            exact
            path="/"
            element={<HomeScreen storeCurrency={storeCurrency} />}
          />
          <Route
            exact
            path="/product/:id"
            element={<ProductScreen storeCurrency={storeCurrency} />}
          />
          <Route
            exact
            path="/cart"
            element={
              <CartScreen
                storeCurrency={storeCurrency}
                currentUser={currentUser}
              />
            }
          />
          <Route
            exact
            path="/account"
            element={
              <Account
                currentUser={currentUser}
                storeCurrency={storeCurrency}
              />
            }
          />
          <Route exact path="/register" element={<RegisterScreen />} />
          <Route
            exact
            path="/order"
            element={
              <OrderScreen
                storeCurrency={storeCurrency}
                currentUser={currentUser}
              />
            }
          />
          <Route
            exact
            path="/confirmation"
            element={<CheckOutSuccess storeCurrency={storeCurrency} />}
          />
          <Route
            exact
            path="/shop"
            element={<Shop storeCurrency={storeCurrency} />}
          />
          <Route exact path="/about" element={<AboutScreen />} />
          <Route exact path="/privacy" element={<PrivacyPolicy />} />
          <Route exact path="/contact" element={<ContactScreen />} />
          <Route
            exact
            path="/term-conditions"
            element={<TermAndConditions />}
          />
        </Routes>
        <Footer storeName={storeName} />
      </Router>
    </main>
  );
}

export default App;
